import { createCustomEvent } from "../../shared/helpers"

export default class extends Controller {
  static targets = ["submitButton", "startField"]

  connect() {
    App.TimeEntries.initEntryForm(this.element)
    App.Helpers.addAjaxHandlers(this.element, this.afterSubmit.bind(this), this.replaceSelfWithResponse.bind(this))
  }

  startTimer(event) {
    event && event.preventDefault()
    this.setRunningTimer = true
    this.submitEntryForm(event)
  }

  logTime(event) {
    event && event.preventDefault()
    this.setRunningTimer = false
    this.submitEntryForm(event)
  }

  submitEntryForm(event) {
    if (!event.currentTarget.disabled) {
      this.submitButtonTargets.forEach(t => t.disabled = "disabled")
      App.Helpers.submitRemoteForm(this.element)
    }
  }

  afterSubmit(event, { entry }) {
    const { running, redirect } = entry
    App.TimeEntries.executeAfterTimeLogFor(entry)
    if (running) {
      document.dispatchEvent(createCustomEvent("timer-started", this.element))
    }
    if (!App.skipRedirectAfterTimeEntry && redirect) {
      window.location.replace(data.redirect)
    }
    this.closeForm()
  }

  replaceSelfWithResponse(event, { responseText }) {
    App.Helpers.replaceElement(this.element, responseText)
  }

  closeForm(event) {
    event && event.preventDefault()
    App.SlideOut.close({ element: this.element })
  }

  set action(_action) {
    this.data.set("action", _action)
  }

  get action() {
    return this.data.get("action") || "start"
  }

  set setRunningTimer(val) {
    this.startFieldTarget.value = val ? "1" : ""
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/time-entries/time-entry-form-controller.js